import type { Obstacle, Sensor } from '../api/models';

export type ImageDragTransform = {
  pivotStart: [number, number];
  pivotEnd: [number, number];
  scaleFactor: number;
};

/** Map a world position through the same XY translate+scale as the reference image drag. */
export const transformPositionWithImageDrag = (
  position: [number, number, number],
  { pivotStart, pivotEnd, scaleFactor }: ImageDragTransform,
): [number, number, number] => [
  pivotEnd[0] + (position[0] - pivotStart[0]) * scaleFactor,
  pivotEnd[1] + (position[1] - pivotStart[1]) * scaleFactor,
  position[2],
];

export const scaleSensorsWithImageDrag = (
  sensors: Sensor[],
  transform: ImageDragTransform,
): Sensor[] =>
  sensors.map((sensor) => ({
    ...sensor,
    position: transformPositionWithImageDrag(sensor.position, transform),
    ...(sensor.designPosition
      ? { designPosition: transformPositionWithImageDrag(sensor.designPosition, transform) }
      : {}),
  }));

export const scaleObstaclesWithImageDrag = (
  obstacles: Obstacle[],
  transform: ImageDragTransform,
): Obstacle[] =>
  obstacles.map((obstacle) => ({
    ...obstacle,
    position: transformPositionWithImageDrag(obstacle.position, transform),
    size: [
      obstacle.size[0] * transform.scaleFactor,
      obstacle.size[1] * transform.scaleFactor,
      obstacle.size[2],
    ],
  }));
